import { render } from "./OneTimePassword.vue?vue&type=template&id=cf6a0ce8&scoped=true"
import script from "./OneTimePassword.vue?vue&type=script&lang=js"
export * from "./OneTimePassword.vue?vue&type=script&lang=js"

import "./OneTimePassword.vue?vue&type=style&index=0&id=cf6a0ce8&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf6a0ce8"]])

export default __exports__